module.exports = __webpack_public_path__ + "static/media/performance-subject.60689c59.svg";